export default __webpack_public_path__ + "static/media/animation_success.a3a7e51c.gif";